import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'

import * as SC from './styled'

export type ClosedTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  text: string
  text2: string
}

const ClosedTemplate: FC<ClosedTemplateProps> = (props) => {
  const { layout, text, text2 } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.ContentBox>
          <SC.Text>{text}</SC.Text>
          <SC.Text>{text2}</SC.Text>
          <SC.Text $bold={true}>Balenciaga</SC.Text>
        </SC.ContentBox>
      </SC.Content>
    </DefaultLayout>
  )
}

export default ClosedTemplate
